import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAppSelector } from '../../hooks/reduxHooks'

const Redirect = () => {
	const isAuth = useAppSelector((state) => state.app.isAuth)

	if (isAuth) {
		return <Navigate to="/vacancies" />
	} else {
		return <Navigate to="/login" />
	}
}

export default Redirect
